/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const enterpriseAgreement = {
  path: '/enterprise-agreement',
  component: Layout,
  redirect: '/enterprise-agreement',
  name: 'EnterpriseAgreement',
  meta: {
    title: 'enterpriseAgreement',
    icon: 'zijinrizhi',
    perm: 'zqxyManage'
  },
  children: [
    {
      path: 'agreement-list',
      component: () => import('@/views/enterprise-agreement/agreement-list/index.vue'),
      name: 'AgreementList',
      meta: {
        title: 'agreementList'
      }
    }
  ]
}
export default enterpriseAgreement
